import { render, staticRenderFns } from "./competitionDownload.vue?vue&type=template&id=64ab61d5&scoped=true&"
import script from "./competitionDownload.vue?vue&type=script&lang=ts&"
export * from "./competitionDownload.vue?vue&type=script&lang=ts&"
import style0 from "./competitionDownload.vue?vue&type=style&index=0&id=64ab61d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab61d5",
  null
  
)

export default component.exports